import React from 'react';

const NoteIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" strokeWidth="1.5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.5 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V19C3 20.1 3.9 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V8.5L15.5 3Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M15 3V9H21" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default NoteIcon;